import { AnyAction } from 'redux';
import { call } from 'redux-saga/effects';
import { ExceptionsService } from '../exceptions';

interface ErrorDetails {
  readonly saga: string;
  readonly action: AnyAction;
}

/**
 * @deprecated Please use {@link catchSagaError} instead
 */
export class BaseSagaClass {
  static *catchError(error: Error, details: Partial<ErrorDetails> = {}) {
    yield call(ExceptionsService.captureException, error, {
      extra: details,
    });
  }
}
